import CryptoJS from 'crypto-js'
const key = CryptoJS.enc.Utf8.parse('	') // 十六位十六进制数作为密钥
const iv = CryptoJS.enc.Utf8.parse('				')// 十六位十六进制数作为密钥偏移量
/**
   * 加密方法
   * 
   */
export const encryptDes = (word) => {
  if (word) {
    var encrypted = CryptoJS.DES.encrypt(word, key, { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 })
    return encrypted.toString()
  } else {
    return ''
  }
}

/**
   * 解密方法
   * 
   */
export const decryptDes = (word) => {
  if (word) {
    var decrypt = CryptoJS.DES.decrypt(word, key, { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 })
    return decrypt.toString(CryptoJS.enc.Utf8)
  } else {
    return ''
  }
}


//此处加解密为分享时  datetime的加解密方式   否则会地址解析错误
/**
 * @desc 解密方法
 */
export function DecryptAES(word) {
  if (word) {
    let encryptedHexStr = CryptoJS.enc.Hex.parse(word);
    let srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr);
    let decrypt = CryptoJS.AES.decrypt(srcs, key, { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });
    let decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
    return decryptedStr.toString();
  } else {
    return ''
  }
}
/**
 * @desc 加密方法
 * @param {需加密字段}  
 * @return {加密字段} 
 */

export function EncryptAES(word) {
  if (word) {
    let srcs = CryptoJS.enc.Utf8.parse(word);
    let encrypted = CryptoJS.AES.encrypt(srcs, key, { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });
    return encrypted.ciphertext.toString().toUpperCase();
  } else {
    return ''
  }
}